import isCustomBlock from '../verifiers/is-custom-block';
import getRootBlockByElement from './get-root-block-by-element';
import isElementColumn from './is-element-column';

function isElementColumnInCustomBlock(element) {
  if (!element) return false;
  const rootBlock = getRootBlockByElement(element);
  const isOneColumnLayout =
    element.getAttribute('widget') === 'columns' &&
    element.querySelectorAll('ws-column').length === 1;
  return (isElementColumn(element) || isOneColumnLayout) && isCustomBlock(rootBlock);
}

export default isElementColumnInCustomBlock;
